import { all, takeLatest, put, call } from 'redux-saga/effects';
import { getCityStateByZipCode } from 'yoda-interfaces/lib/Zipcode/ZipcodeApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import * as AddressingConstActionTypes from '../actionTypes/AddressingConstActionTypes';

export function* getCityStateByZipcodeSaga(action) {
    try {
        const response = yield call(FactorySaga, getCityStateByZipCode, action);
        const payload = {
            response: response.data || response.response.data,
        };
        payload.isLoading = false;
        if (response.isSuccess) {
            payload.isSuccess = true;
            yield all([
                put({ type: AddressingConstActionTypes.GET_ADDRESSING_ZIP_CODE_SUCCESS, payload }),
            ]);
        } else {
            payload.isSuccess = false;
            payload.error = response.data || response.response.data;
            yield put({
                type: AddressingConstActionTypes.GET_ADDRESSING_ZIP_CODE_ERROR,
                payload,
            });
        }
    } catch (error) {
        yield put({
            type: AddressingConstActionTypes.GET_ADDRESSING_ZIP_CODE_ERROR,
            payload: {
                isSuccess: false,
                error,
            },
        });
    }
}

function* watchAddressingConstSaga() {
    yield takeLatest(AddressingConstActionTypes.GET_ADDRESSING_ZIP_CODE, getCityStateByZipcodeSaga);
}

watchAddressingConstSaga.sagaName = 'addressingConstSaga';
export default watchAddressingConstSaga;
